import { ChatMessage } from '../types'

import { getAiChatUuid } from './chat-session'
import { createFetchChatStream } from './chat-stream'

const AI_CHAT_MESSAGE_PROXY = '/api/ai-bot/ai-chat-message'

const buildProxyUrl = (
	uuid: string,
	message: string,
	phone: string | undefined,
	title: string,
	pageUrl: string
): string => {
	const params = new URLSearchParams({ uuid, message })

	if (phone) params.set('meta[phone]', phone)
	if (title) params.set('meta[page][title]', title)
	if (pageUrl) params.set('meta[page][url]', pageUrl)

	return `${AI_CHAT_MESSAGE_PROXY}?${params.toString()}`
}

export type ChatMessageStreamHandlers = {
	onMessage: (value: string) => void
	onDelta: (value: string) => void
	onTitleSet?: (value: string) => void
	onFinal?: (value: string, meta: ChatMessage['meta']) => void
	onCloseChat?: () => void
	onCallOperator?: () => void
	onShowPersonalAccount?: () => void
	onAddToBasket?: (value: string[]) => void
}

export const sendChatMessage = async ({
	message,
	phone,
	onMessage,
	onDelta,
	onTitleSet,
	onFinal,
	onCloseChat,
	onCallOperator,
	onShowPersonalAccount,
	onAddToBasket
}: ChatMessageStreamHandlers & { message: string; phone?: string }): Promise<{
	close: () => void
}> => {
	const uuid = await getAiChatUuid()
	const title = document.title
	const pageUrl = window.location.href
	const url = buildProxyUrl(uuid, message, phone, title, pageUrl)

	const stream = createFetchChatStream(url, {
		onDescription: onMessage,
		onTitleSet,
		onDelta,
		onFinal,
		onCloseChat,
		onCallOperator,
		onShowPersonalAccount,
		onAddToBasket,
		onError: error => {
			console.error('AI chat connection error', error)
		}
	})

	return stream
}
